/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class Pricing extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div id="tickets" className="section  --white m0 block-4 z-21">
                    <div className="container p-40   relative-text">
                        <div className="row mb0">
                            <div className="col s12 p0 center-align">
                                <h1 className="f-62 ls-3 white-text bold-text text-uppercase mb0">GET YOUR<br/>
                                    <span className="f-100 ls-6 brant-text">TICKETS</span>
                                </h1>
                                <p className="white-text f-16 pb-8">UPON ARRIVAL, YOU WILL BE ABLE TO NETWORK WITH AN ELITE GROUP OF ANGEL INVESTORS, ENTREPRENEURS, TECHNOLOGIST, BLOCKCHAIN ENTHUSIASTS AND DIGITAL MARKETERS.</p>
                            </div>
                        </div>
                    </div>

                    <div className="p-40 relative-text">
                        <div className="row mb0">
                            <div className="col s12 m4">
                                <div className="col s12">
                                    <div className="row mb0 brand-gradient grey-border-all p-20">
                                        <div className="col s12 center-align">
                                            <p className="white-text f-22 bold-text text-uppercase">HACKER PASS</p>
                                            <p className="white-text f-18">FREE!</p>
                                        </div>
                                    </div>
                                    <div className="row mb0 white grey-border-all p-20">
                                        <div className="col s12 p0">
                                            <div className="white">
                                                <div className="col s12 center-align">
                                                    <p className="grey-text f-14 text-uppercase">Oct 19 - 21</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb0 white grey-border-all p-20">
                                        <div className="col s12 p0">
                                            <div className="white">
                                                <div className="col s12 center-align">
                                                    <p className="grey-text f-14 text-uppercase">Hackathon Only</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb0 white grey-border-all p-20">
                                        <div className="col s12 p0">
                                            <div className="white">
                                                <div className="col s12 center-align">
                                                    <p className="grey-text f-14 text-uppercase">Over $15,000 in Cash Prizes</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row mb-20">
                                    <div className="col s12">
                                        <br/>
                                        <a target="_blank" href="https://www.eventbrite.com/e/disrupt-bayamon-hackathon-at-engine-4-tickets-49791230912" className="btn-large black-btn waves-effect waves-light col s12">GET TICKETS</a>
                                    </div>
                                </div>
                            </div>

                            <div className="col s12 m4 pb-20">
                                <div className="col s12">
                                    <div className="row mb0 brand-gradient grey-border-all p-20">
                                        <div className="col s12 center-align">
                                            <p className="white-text f-22 bold-text text-uppercase">Community Pass</p>
                                            <p className="white-text f-18">FREE! <strike className="red-text">$499</strike></p>
                                        </div>
                                    </div>
                                    <div className="row mb0 white grey-border-all">
                                        <div className="col s12 p0">
                                            <div className="white">
                                                <div className="row mb0 white grey-border-all p-20">
                                                    <div className="col s12 p0">
                                                        <div className="white">
                                                            <div className="col s12 center-align">
                                                                <p className="grey-text f-14 text-uppercase">Oct 22 - 25</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Full ACCESS</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">ACCESS TO SELECT COMMUNITY WORKSHOPS, MEETUPS, & EVENTS</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">ACCESS TO SELECT NIGHT LIFE, HAPPY HOURS & AFTER PARTIES</p>
                                                    </div>
                                                </div>
           
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-20">
                                    <div className="col s12">
                                        <br/>
                                        <a target="_blank" href="https://www.eventbrite.com/e/disrupt-week-community-pass-tickets-50209686524" className="btn-large black-btn waves-effect waves-light col s12">GET TICKETS</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col s12 m4 pb-20">
                                <div className="col s12">
                                    <div className="row mb0 brand-gradient grey-border-all p-20">
                                        <div className="col s12 center-align">
                                            <p className="white-text f-22 bold-text text-uppercase">VIP PASS</p>
                                            <p className="white-text f-18">$999 + TAX</p>
                                        </div>
                                    </div>
                                    <div className="row mb0 white grey-border-all">
                                        <div className="col s12 p0">
                                            <div className="white">
                                                <div className="row mb0 white grey-border-all p-20">
                                                    <div className="col s12 p0">
                                                        <div className="white">
                                                            <div className="col s12 center-align">
                                                                <p className="grey-text f-14 text-uppercase">Oct 26 - 27</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">EXCLUSIVE VIP ACCESS</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Access to all workshops, panels, talks & keynotes</p>
                                                    </div>
                                                </div>
                                                 <div className="row mb0 white grey-border-bottom p-20 ">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">VIP lunch with speakers & sponsors</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20 ">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">VIP Boat Party with speakers & sponsors</p>
                                                    </div>
                                                </div>
                                  
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-20">
                                    <div className="col s12">
                                        <br/>
                                        <a target="_blank" href="https://ti.to/disrupt-puerto-rico/disrupt-puerto-rico-2018" className="btn-large orange waves-effect waves-light col s12">BUY TICKETS</a>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default Pricing;


// WEBPACK FOOTER //
// ./src/components/pricing.js